module.exports = __webpack_public_path__ + "c52e2f0d8ea13d396f956f46784bee32.png";